import { render, staticRenderFns } from "./EditSocialMedia.vue?vue&type=template&id=104260ab&scoped=true&"
import script from "./EditSocialMedia.vue?vue&type=script&lang=js&"
export * from "./EditSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104260ab",
  null
  
)

export default component.exports